/**
 * Nutzer-Grund eines fehlgeschlagenen Portal-Formulars (Kontakt, Zählerstand) für die
 * `*.form_error`-Events — oder null, wenn KEIN Event gesendet werden soll.
 *
 * Nur Nutzer-Fehler zählen als Formularfehler. Technische Fehler erfasst io.center
 * serverseitig per base_monitoring (portal.app/contact_send_failed,
 * portal.energy/meter_reading_save_failed); das Frontend sendet dafür nichts. Reihenfolge:
 *   1. kein Response (Netzwerk) oder Status außerhalb 4xx → null
 *   2. `response.data.code` gesetzt: fachlicher Code → dieser Code; Technik-Code
 *      (`send_failed`, `validate_request_failed`, `send_request_failed` — kommen als 422!)
 *      oder unbekannter Code → null, NIE der 422-Fallback
 *   3. ohne Code: 422 → `validation`; nur Zählerstand: 403/404 → `meter_not_found`
 *      (fremder bzw. unbekannter Zähler); alles andere → null
 *
 * Die Codes sind mit dem io.center-Backend abgestimmt; neue fachliche Codes hier ergänzen.
 */

export type PortalForm = 'contact' | 'meter_reading';

/** Fachliche Codes aus `response.data.code` — werden zum `name` des Events. */
export const FORM_ERROR_USER_CODES: readonly string[] = [
  'reading_too_early',
  'no_active_contract',
  'reading_rejected',
  'duplicate_submission',
];

export function formErrorReason(error: unknown, form: PortalForm): string | null {
  const response = (error as { response?: { status?: number, data?: unknown } } | null)?.response;
  const status = Number(response?.status);

  if (!response || !Number.isInteger(status) || status < 400 || status >= 500) {
    return null;
  }

  const code = (response.data as { code?: unknown } | null | undefined)?.code;
  if (code !== undefined && code !== null && code !== '') {
    return typeof code === 'string' && FORM_ERROR_USER_CODES.includes(code) ? code : null;
  }

  if (status === 422) {
    return 'validation';
  }

  if (form === 'meter_reading' && (status === 403 || status === 404)) {
    return 'meter_not_found';
  }

  return null;
}
